import { initSentry } from '@aloft/toolkit-shared/src/sentry/frontend.ts';
import { SoundUIProvider } from '@aloft/toolkit-sui';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { QueryWrapper } from './QueryWrapper.tsx';
import { router } from './controller/routes/router.tsx';
import { initLogger } from './logging/logging.ts';
import { ToolkitReduxProvider } from './redux/ToolkitReduxProvider.tsx';
import { toolkitTheme } from './styles/toolkitTheme.ts';

initSentry();
initLogger();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ToolkitReduxProvider>
      <SoundUIProvider themes={[toolkitTheme]}>
        <QueryWrapper>
          <RouterProvider router={router} />
        </QueryWrapper>
      </SoundUIProvider>
    </ToolkitReduxProvider>
  </React.StrictMode>,
);
